import { Component, EventEmitter, Input, OnInit, Output, Signal, signal, SkipSelf, ViewChild } from '@angular/core';

import { ActivatedRoute, Router } from "@angular/router";
import { MessageService } from "primeng/api";
import { TranslateService } from "@ngx-translate/core";
import {
  BaseControl, ControlType, Form, FormCreatorService,
  FormPage, LoadingPanelService, CustomTitle, IFormEvent,
  BuscarSisbenComponent,
  IsearchJefeHogar
} from 'lib-base';
import { firstValueFrom, forkJoin } from "rxjs";
import { DividerModule } from "primeng/divider";
import { StyleClassModule } from "primeng/styleclass";
import { FormViewerComponent } from "../../../../../tramitantes/src/app/components/form-viewer/form-viewer.component";
import { ProcesarTramiteComponent } from "../../../../../tramitantes/src/app/pages/tramitante/procesar-tramite/procesar-tramite.component";
import { INucleoFamiliar, TipoSolicitudSisben } from "../../shared/interface/sisben";
import { CreateTramiteRegistroRequest } from "../../../../../tramitantes/src/app/shared/interfaces/liquidacion";
import { NucleoFamiliarService } from "../../services/nucleo-familiar.service";
import { FormularioService } from "../../../../../tramitantes/src/app/services/formulario.service";
import { TramitesSisben } from "../../shared/classes/TramitesSisben";
import { InformacionSisbenComponent } from '../informacion-sisben/informacion-sisben.component';
import { ITipoIdentificacion } from '../../../../../tramitantes/src/app/shared/interfaces/seguridad';
import { TipoIdentificacionService } from '../../../../../tramitantes/src/app/services/tipoIdentificacion.service';


@Component({
  selector: 'app-tramite-sisben',
  standalone: true,
  imports: [
    FormViewerComponent,
    ProcesarTramiteComponent,
    BuscarSisbenComponent,
    InformacionSisbenComponent,
    DividerModule,
    StyleClassModule,
    CustomTitle
  ],
  providers: [FormCreatorService],
  templateUrl: './tramite-sisben.component.html',
})
export class TramiteSisbenComponent implements OnInit {

  @Input('titulo') titulo!: string;
  private _dependenciaId !: number;
  private _tramiteId !: number;
  private _translations: any = {};
  private form: Signal<Form> | undefined = undefined;
  formPages: Signal<FormPage[]> | undefined = undefined;
  @Input({ required: true }) tipoSolicitud!: TipoSolicitudSisben;
  private itemsSelected: INucleoFamiliar[] = [];

  @Output() eventForm: EventEmitter<IFormEvent> = new EventEmitter<IFormEvent>();

  @ViewChild(BuscarSisbenComponent, { static: true }) _buscarComponent!: BuscarSisbenComponent;
  @ViewChild(InformacionSisbenComponent) _informacionComponent!: InformacionSisbenComponent;
  @ViewChild(FormViewerComponent) _formViewerComponent !: FormViewerComponent;
  @ViewChild(ProcesarTramiteComponent) _procesarTramite !: ProcesarTramiteComponent;

  tiposIdentificaciones: ITipoIdentificacion[] = [];

  constructor(private readonly route: ActivatedRoute,
    public messageService: MessageService,
    private readonly _t: TranslateService,
    private readonly _router: Router,
    private readonly nucleoFamiliarService: NucleoFamiliarService,
    private readonly _lps: LoadingPanelService,
    public readonly fc: FormCreatorService,
    private readonly _fs: FormularioService,
    private tipoIdentificacionService: TipoIdentificacionService,
    @SkipSelf() private parentComponent: TramitesSisben) {
    this.onSubmitForm = this.onSubmitForm.bind(this);
    const options = {
      isDesigner: false,
      enableSubmit: true
    }
    this.fc.setOptions(options);
    this.getTipoIdentificacion();
  }

  ngOnInit(): void {
    this.initRouteVariables();    
    this.getTranslate().then();
    this.fc.formEventSubject.subscribe((event: any) =>
      this.eventForm.emit(event)
    );
    this.fc.eventSubjectClearForm
      .subscribe((event: any) => {
        this._buscarComponent.existData = false;
        this._buscarComponent.onClean();
      })
  }

  private initRouteVariables(): void {
    this._dependenciaId = Number(this.route.snapshot.params['dependenciaId']);
    this._tramiteId = Number(this.route.snapshot.params['tramiteId']);
    if (!this._dependenciaId || !this._tramiteId) {
      //TODO SALIR DE LA VISTA EN CASO DE NO TENER PARAMETROS
    }
  }

  private async getTranslate(): Promise<void> {
    this._translations = await firstValueFrom(forkJoin({
      aceptar: this._t.get('form.button.aceptar'),
      cargando: this._t.get('msg.cargando'),
      summarySuccess: this._t.get('form.msg.success-summary'),
    }));
  }

  getSearchValues($event: IsearchJefeHogar) {
    this._informacionComponent.props = $event;
    this.getInformation($event)
      .then((result) => {
        if (result) {
          if (!this.form) {
            this.getFormulario().then(() => {
              this.setFormulario();
              this.loadData(this.jefeHogar)
            });
            return;
          }
          this.setFormulario();
          this.loadData(this.jefeHogar)
        }
      });
  }

  clearSearch(): void {
    if (this._informacionComponent) {
      this._informacionComponent.clearData();
      this._buscarComponent.existData = false;
      this.messageService.add({
        severity: 'success',
        summary: this._translations.summarySuccess,
        detail: 'Formulario restablecido'
      })
    }
    this.fc.resetForm();
    this.itemsSelected = [];
  }

  async getInformation(props: IsearchJefeHogar): Promise<boolean> {
    this._lps.show();
    return await firstValueFrom(this.nucleoFamiliarService
      .getJefeFamiliaByTipoIdAndDNI(props.tipoIdentificacion, props.identificacion))
      .then(data => {
        this._lps.hide();
        if (this._informacionComponent)
          this._informacionComponent.setInformacioJefeHogar(data);
        this.getNucleoFamiliar(data.id);
        this._buscarComponent.existData = true;
        return true;
      })
      .catch(err => {
        const { error } = err;
        this.messageService.add({
          severity: 'warn',
          summary: error.error,
          detail: error.message
        });
        this._buscarComponent.existData = false;
        return false;

      })

  }

  getNucleoFamiliar(id: number) {
    if (!id) return;
    this.nucleoFamiliarService.getNucleoFamiliar(id).subscribe({
      next: data => {
        if (this._informacionComponent)
          this._informacionComponent.setNucleoFamiliar(data);
      }
    })
  }

  handlerEdit(value: any) {
    if (this.validaAndAgregaItem(value)) {
      this.parentComponent.modificar(value);
    }
  }

  handlerDelete(value: any) {
    if (this.validaAndAgregaItem(value)) {
      this.parentComponent.eliminar(value);
    }
  }

  private validaAndAgregaItem(value: any): boolean {
    if (this.existItem(value)) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atención',
        detail: 'La persona ya ha sido seleccionada y agregada al formulario'
      })
      return false;
    }
    this.itemsSelected.push(value);
    return true;
  }

  loadData(data: any): void {
    if (!this.form) return;
    const pages = this.getFormPages(this.form() as Form);
    if (!pages) return;
    this.formPages = signal(pages);
    if (this.formPages().length > 0) {
      const page = this.formPages()[0];
      const formValue = this.createObjectDataForm(page, data);
      this.fc.loadRespuesta(JSON.stringify(formValue));
    }
  }

  private createObjectDataForm(page: FormPage, data: any) {
    const formValue: any = {};
    formValue[page.name] = {};
    const controls: BaseControl<any>[] = page.controls
      ?.filter((item: any) =>
        ![ControlType.Label, ControlType.SubFormulario].includes(item.type));
    controls?.forEach((control: BaseControl<any>) => {
      formValue[page.name][control.name] = data[control.name];
    });
    return formValue;
  }

  getFormPages(data: Form): FormPage[] | undefined {
    if (!data) return undefined;
    const value = JSON.parse(data.contenido || "{}");
    if (!value) return undefined;
    return value.pages;
  }


  private async getFormulario(): Promise<void> {
    if (!this._tramiteId && this._dependenciaId) return;
    return await firstValueFrom(this._fs.getFormularioByTipoTramiteId(this._dependenciaId, this._tramiteId))
      .then((response: Form) => {
        this._procesarTramite.requierePago = response.requierepago;
        this._procesarTramite.fuentePago = response.fuentedepago;
        if (response.requierepago && !response.costovigente) {
          this.messageService.add({
            severity: 'error',
            summary: 'Failed to load',
            detail: this._translations.tramiteInactivo
          });
          this._router.navigate(['/public/consulta']).then();
          return
        }
        this.form = signal(response);
      })
      .catch(err => {
        this.messageService.add({
          severity: 'error',
          summary: 'Failed to load',
          detail: err.message
        });
      });

  }

  onSubmitForm(data: string) {
    if (!this.parentComponent.validate()) return;
    let newTramite = {
      tipoTramiteId: this._tramiteId,
      dependenciaId: this._dependenciaId,
      respuesta: data,
      parametros: this.parentComponent.getParams()
    } as CreateTramiteRegistroRequest;
    this._lps.show();
    this.parentComponent.submitForm(newTramite).then((response: any) => {
      this._lps.hide();
      this._procesarTramite.showEnviarTokenFirmaElectronica(response);
    }).catch(() => {
      this._lps.hide();
    })

  }

  private setFormulario(): void {
    if (!this.form || !this.form()) return;
    const form = this.form() as Form;
    this.fc.Form.title = form?.nombre ?? '';
    this.fc.loadForm(form);
  }

  get jefeHogar() {
    return this._informacionComponent?._jefeHogar;
  }

  get isModificacion() {
    return this.tipoSolicitud == TipoSolicitudSisben.MODIFICAR_DOCUMENTO;
  }

  get isEliminacion() {
    return this.tipoSolicitud == TipoSolicitudSisben.ELIMINAR_MIEMBRO;
  }


  private existItem(value: INucleoFamiliar): boolean {
    return this.itemsSelected.find(item => item.id == value.id) != undefined;
  }

  get nucleoFamiliar() {
    return this.itemsSelected;
  }

  deleteItem(predicate: any): void {
    if (!this.nucleoFamiliar) return;
    const indx = this.nucleoFamiliar?.findIndex(predicate);
    this.nucleoFamiliar?.splice(indx, 1)
  }

  private getTipoIdentificacion() {
    this.tipoIdentificacionService.getTipoIdentificaciones().subscribe({
      next: data => {
        this.tiposIdentificaciones = data;
      }
    })
  }
}
